// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2sLoG","col":"styles_col__1p9ZE","fulfillmentStatus":"styles_fulfillmentStatus__6buL2","emailCol":"styles_emailCol__2UDBf"};